import { createFileRoute } from '@tanstack/react-router';
import { loadCatalogDetail } from '@/features/catalog/queries';
import { ApiDetailPage } from '../../../../pages/ApiDetailPage';

// Dashboard catalog browse (ssr:false, no SEO). Shares the loader shape with the
// marketing /api/:apiId route so ApiDetailPage gets its detail via props; the
// loader simply runs on the client here.
export const Route = createFileRoute('/dashboard/catalog/$apiId/')({
  loader: ({ context, params }) => loadCatalogDetail(context.queryClient, params.apiId),
  component: ApiDetailRoute,
});

function ApiDetailRoute() {
  const { apiId } = Route.useParams();
  const { detail, icon } = Route.useLoaderData();
  return <ApiDetailPage apiId={apiId} detail={detail} icon={icon} presentation="dashboard" />;
}
